import { ExportGapFilterType } from "@app/exports/enumerations";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { FC, useContext, useMemo } from "react";
import { UserContext } from "@app/user/UserContext";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import { ReportCustomizationReducerActions } from "../interfaces/reportCustomizationReducerActionsEnum";
import { ReportType } from "../interfaces/reportTypeEnum";
import { getSpecialtyGapTypes } from "../helpers";
import { ReportCustomizationContext } from "../ReportCustomizationContext";

export const SpecialtySection: FC = () => {
  const rcContext = useContext(ReportCustomizationContext);
  const user = useContext(UserContext);
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;
  const isChangedGapsReport = !!rcContext.state.changedGapsType;

  const specialtyGapTypesOptions = useMemo(() => {
    const options = getSpecialtyGapTypes(user.roles, featureFlags);
    return options.map((o) => <option key={o.key} value={o.key}>{o.value}</option>);
  }, [user.roles, featureFlags]);

  const allSpecialtiesSelected = useMemo(() => {
    const allSpecialties = rcContext.state.allSpecialties.map((specialty) => specialty.key);
    return allSpecialties.length === rcContext.state.selectedSpecialties.length && allSpecialties.every((specialtyKey) => rcContext.state.selectedSpecialties.find((s) => s.key === specialtyKey));
  }, [rcContext.state.selectedSpecialties, rcContext.state.allSpecialties]);

  return (
    <>
      <div className="row mt-3">
        <h2 className="header-s col-auto">Specialty</h2>
      </div>
      <div className="row">
        <MultiselectDropdown
          containerClassName="col-4"
          customSelectInputText={allSpecialtiesSelected ? "All Specialties" : undefined}
          items={rcContext.state.allSpecialties}
          label="Specialty Groups"
          selectedItems={rcContext.state.selectedSpecialties}
          onSelectionChanged={(newSelections) => rcContext.dispatch({ payload: { selectedSpecialties: newSelections }, type: ReportCustomizationReducerActions.ChangeSelectedSpecialtes })}
          disabled={rcContext.state.allSpecialties.length === 0 || isChangedGapsReport}
          testId="report-customization__specialties"
        />

        <QESSelect
          containerClassName="col-4"
          label="Specialty Gaps"
          value={rcContext.state.specialtyGapsType}
          onChange={(e) => rcContext.dispatch({ payload: { specialtyGapsType: e.target.value as ExportGapFilterType }, type: ReportCustomizationReducerActions.ChangeSpecialtyGapsType })}
          disabled={isChangedGapsReport}
          testId="report-customization__specialty-gaps"
        >
          {specialtyGapTypesOptions}
        </QESSelect>
      </div>

      <QESCheckbox
        containerClassName="row ml-1"
        label="Physician specialties"
        checked={rcContext.state.includePhysicianSpecialties}
        onChange={(e) => rcContext.dispatch({ payload: { includePhysicianSpecialties: e.target.checked }, type: ReportCustomizationReducerActions.ChangeIncludePhysicianSpecialties })}
        disabled={isChangedGapsReport}
        testId="report-customization__include-physician-specialties"
      />
      <QESCheckbox
        containerClassName="row ml-1"
        label="Facility specialties"
        checked={rcContext.state.includeFacilitySpecialties}
        onChange={(e) => rcContext.dispatch({ payload: { includeFacilitySpecialties: e.target.checked }, type: ReportCustomizationReducerActions.ChangeIncludeFacilitySpecialties })}
        disabled={isChangedGapsReport}
        testId="report-customization__include-facility-specialties"
      />
      {rcContext.routeState.showExpandableSpecialties && rcContext.state.reportType === ReportType.SpecialtySummaryByCounty && (
        <QESCheckbox
          containerClassName="row ml-1"
          label="Expandable specialties"
          checked={rcContext.state.includeExpandableSpecialties}
          onChange={(e) => rcContext.dispatch({ payload: { includeExpandableSpecialties: e.target.checked }, type: ReportCustomizationReducerActions.ChangeIncludeExpandableSpecialties })}
          disabled={isChangedGapsReport}
          testId="report-customization__include-expandable-specialties"
        />
      )}
    </>
  )
}